<template>
  <div class="parameter-container">
    <!-- 连接状态提示区域 -->
    <div v-if="isReconnecting" class="connection-status">
      <el-alert
        :title="reconnectMessage"
        type="warning"
        :closable="false"
        show-icon
      />
    </div>
    
    <div class="content-wrapper">      
      <div class="data-grid">
        <div 
          class="data-item" 
          v-for="(param) in sortedFlatData" 
          :key="`${param.varName}-${param.deviceCode}-${isVariableSelected(param)}`"
          :class="{ 'selected': isVariableSelected(param) }"
        >
          <!-- 复选框 -->
          <div class="checkbox-section" v-if="!isInvalidTitle(param.title)">
            <el-checkbox 
              :model-value="isVariableSelected(param)"
              @change="(checked) => handleVariableSelection(param, checked)"
              class="inline-checkbox"
            >
              <div class="checkbox-content" >
                <div class="single-row-layout">
                  <!-- 标题和变量名区域 -->
                  <div class="title-var-area">
                    <div class="checkbox-container">
                      <!-- 复选框会自动放在这里 -->
                    </div>
                    <!-- <span class="title-text">{{ param.title }}({{ param.varName }})</span> -->
                    <span class="title-text">
                      {{ param.title }}
                      <!-- <span v-if="!param.title?.toLowerCase().includes(param.varName?.toLowerCase()) && !param.varName?.toLowerCase().includes(param.title?.toLowerCase())">({{ param.varName }})</span> -->
                    </span>
                  </div>
                  
                  <!-- 报警状态和重置按钮区域:content="`${(param.description ? ` ${param.description}--` : '')} ${formatValidTime(param.updateAt)}`.trim()" -->
                  <div class="alarm-reset-area">
                    <!-- 添加 Tooltip 显示描述信息 -->
                    <el-tooltip
                      v-if="param.description && param.description.trim() !== ''"                      
                      :content="param.updateAt === '---' || !param.updateAt   ? (param.description ? ` ${param.description}` : '').trim()   : `${(param.description ? ` ${param.description}--` : '')} ${formatValidTime(param.updateAt)}`.trim()"
                      placement="top"
                      :show-after="300"
                      :hide-after="0"
                      effect="light"
                      raw-content
                    >
                      <div 
                        class="alarm-status" 
                        :class="getStatusClass(getAlarmStatus(param))"
                        @click.stop
                      >
                        {{ getStatusText(getAlarmStatus(param),param) }}                
                      </div>
                    </el-tooltip>
                    
                    <!-- 如果没有描述信息，直接显示状态 -->
                    <div 
                      v-else
                      class="alarm-status" 
                      :class="getStatusClass(getAlarmStatus(param))"
                    >
                      {{ getStatusText(getAlarmStatus(param),param) }}                
                    </div>

                    <el-button                     
                      type="primary" 
                      size="small" 
                      @click="handleReset(param)"                      
                      class="reset-btn"
                      :style="{ 
                        opacity: param.varCmdSwitch === 1 ? 1 : 0,
                        pointerEvents: param.varCmdSwitch === 1 ? 'auto' : 'none'
                      }"
                    >                   
                      {{ t("message.ClientDeviceMonitorSystemSettingsAlarmReset.reset") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </el-checkbox>
          </div>
        </div>
      </div>

      <!-- 分页区域 - 移动到底部 -->
      <div class="pagination-container">
        <div class="pagination-actions">
          <el-button 
            type="primary" 
            :icon="Refresh" 
            @click="handleQueryAllDataClick"
            :loading="isQeuryAllLoading"            
            class="refresh-btn"
            v-if="false"
          >
            {{ t("message.ClientProjectMonitorSystemMonitorParmater.queryAllData") }}
          </el-button>

          <el-button 
            type="primary" 
            :icon="Refresh" 
            @click="handleQueryDataClick"
            :loading="isQeuryLoading"            
            class="refresh-btn"
            v-if="false"
          >
            {{ t("message.ClientProjectMonitorSystemMonitorParmater.queryData") }}
          </el-button>

          
          <el-button 
            type="primary" 
            :icon="Refresh" 
            @click="handldUpdateAll"
            :loading="isRollCallLoading"
            :disabled="!isConnected"
            class="refresh-btn"
          >
            {{ t("message.ClientProjectMonitorSystemMonitorParmater.updateAll") }}
          </el-button>
 
      
            <el-button 
              type="primary" 
              :icon="Refresh" 
              @click="handleTrack"              
              :disabled="!isConnected"
              :loading="partDataIsRollCallLoading"
              class="refresh-btn"              
            >
              {{ t("message.ClientProjectMonitorSystemMonitorParmater.track") }}
            </el-button>

            <!-- 在追踪按钮旁边添加专门的停止按钮 -->
            <el-button 
              v-if="isTracking"
              type="danger" 
              @click="stopTracking"              
              class="stop-btn"
            >
              {{ t("message.ClientProjectMonitorSystemMonitorParmater.stopTrack") }}
            </el-button>
                <el-button 
              size="primary" 
              type="primary" 
              @click="showHistoryData"
              class="refresh-btn"
              :disabled="chartVariableNames.length === 0"
            >
            {{ t("message.ClientProjectMonitorSystemMonitorParmater.historyData") }}          
            </el-button>
            
            
            <el-button 
              size="primary" 
              type="primary" 
              @click="showRealTimeChart"
              class="refresh-btn"
              :disabled="chartVariableNames.length === 0"
            >
                 {{ t("message.ClientProjectMonitorSystemMonitorParmater.RealTimePlot") }}   
            </el-button>
        </div>

       <div class="pagination">
          <!-- 左侧：分页器或全部提示 -->
          <div class="pagination-left">
            <el-pagination
              v-if="queryParams.pageSize !== 0"
              v-model:current-page="queryParams.pageNum"
              v-model:page-size="queryParams.pageSize"
              :total="queryParams.totalCount"
              :page-sizes="[10, 20, 30, 50, 100, 0]"
              :layout="'total, prev, pager, next, jumper'"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <div v-else class="all-data-info">              
              {{ t("message.ClientProjectMonitorSystemMonitorParmater.showAllData", {count: sortedFlatData.length}) }}   
            </div>
          </div>
          
          <!-- 右侧：统一的分页大小选择器 -->
          <div class="pagination-right">
            <el-select
              v-model="queryParams.pageSize"
              @change="handleSizeChange"
              class="custom-page-size"
              :placeholder="$t('message.ClientProjectMonitorSystemMonitorParmater.paginationSelect')"
              style="width: 120px;"
            >
              <el-option
                v-for="size in [10, 20, 30, 50, 100, 0]"
                :key="size"
                :label="getPageSizeLabel(size)"
                :value="size"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <!-- 对话框组件保持不变 -->
    <el-dialog
      v-model="hisDataDialogVisible"
      :title="hisDialogTitle"      
      :close-on-click-modal="false"
      fullscreen
      class="custom-dialog"      
    >  
      <!-- 自定义标题 -->
      <template #header>
        <div class="custom-dialog-header">
          <span class="dialog-title">{{ hisDialogTitle }}</span>
          <el-button 
            type="primary" 
            link 
            @click="hisDataDialogVisible = false"
            class="back-button"
          >
            <el-icon><ArrowLeft /></el-icon>            
            {{ t("message.common.exit") }}   
          </el-button>
        </div>
      </template>
                        
      <!-- 弹窗内容容器 -->         
      <div class="dialog-content">
        <ClientProjectHisData 
          v-if="hisDataDialogVisible"
          :varDevices="chartVarDevices"
          :projectName="hisDialogTitle"
          :deviceId="currentDeviceId"
        />      
      </div>      
    </el-dialog>

    <el-dialog
      v-model="realTimePlotDialogVisible"
      :title="realTimePlotTitle"      
      :close-on-click-modal="false"
      fullscreen
      class="custom-dialog"      
    >                          
     <!-- 自定义标题 -->
      <template #header>
        <div class="custom-dialog-header">
          <span class="dialog-title">{{ realTimePlotTitle }}</span>
          <el-button 
            type="primary" 
            link 
            @click="realTimePlotDialogVisible = false"
            class="back-button"
          >
            <el-icon><ArrowLeft /></el-icon>            
            {{ t("message.common.exit") }}   
          </el-button>
        </div>
      </template>
      <div class="dialog-content">
        <ClientProjectRealTimePlot 
          v-if="realTimePlotDialogVisible"
          :varDevices="chartVarDevices"
          :projectName="realTimePlotTitle"
          :deviceId="currentDeviceId"
        />      
      </div> 
    </el-dialog>

      <!-- 指定间隔和指定时间追踪 -->
       <el-dialog
      v-model="TrackDialogVisible"
      :title="$t('message.ClientProjectMonitorSystemMonitorParmater.track')"
      width="500px"
    >
      <div class="edit-dialog-content">
        <el-form :model="trackForm" label-width="140px">
          <!-- 更新方式选择 -->
          <el-form-item :label="$t('message.ClientProjectMonitorSystemMonitorParmater.updateMode')">
            <el-radio-group v-model="trackForm.updateMode">
              <el-radio value="auto">
                {{ $t('message.ClientProjectMonitorSystemMonitorParmater.autoUpdate') }}
              </el-radio>
              <el-radio value="manual">
                {{ $t('message.ClientProjectMonitorSystemMonitorParmater.manualUpdate') }}
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 手动更新间隔选项 -->
          <el-form-item 
            v-if="trackForm.updateMode === 'manual'" 
            :label="$t('message.ClientProjectMonitorSystemMonitorParmater.updateInterval')"
          >
          <el-radio-group v-model="trackForm.manualInterval">
            <el-radio :label="1">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.oneSecond') }}</el-radio>
            <el-radio :label="5">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.fiveSeconds') }}</el-radio>
            <el-radio :label="10">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.tenSeconds') }}</el-radio>
            <el-radio :label="30">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.thirtySeconds') }}</el-radio>
            <el-radio :label="0">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.noUpdate') }}</el-radio>
            <el-radio :label="-1">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.customInterval') }}</el-radio>
          </el-radio-group>
          
          <!-- 自定义间隔输入框 -->
          <div v-if="trackForm.manualInterval === -1" class="custom-interval-input">
            <el-input-number 
              v-model="trackForm.customIntervalValue" 
              :min="1" 
              :max="3600"
              :step="1"
              style="width: 120px; margin-top: 8px;"
              :placeholder="$t('message.ClientProjectMonitorSystemMonitorParmater.enterInterval')"
            />
            <span class="interval-unit">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.seconds') }}</span>
          </div>
        </el-form-item>

        <!-- 自动更新说明 -->
        <el-form-item 
          v-if="trackForm.updateMode === 'auto'" 
          :label="$t('message.ClientProjectMonitorSystemMonitorParmater.updateInfo')"
        >
          <div class="auto-update-info">
            <el-icon><InfoFilled /></el-icon>
            <span>{{ $t('message.ClientProjectMonitorSystemMonitorParmater.autoUpdateDesc') }}</span>
          </div>
        </el-form-item>

        <!-- 追踪持续时间 -->
        <el-form-item :label="$t('message.reaTimePlot.duration')">
          <div class="duration-input">
            <el-input-number 
              v-model="trackForm.durationValue" 
              :min="1" 
              :max="480"
              style="width: 120px;"
            />
            <span class="duration-unit">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.minutes') }}</span>
          </div>
          <div class="duration-tips">
            {{ $t('message.ClientProjectMonitorSystemMonitorParmater.durationTips') }}
          </div>
        </el-form-item>

        <!-- 追踪状态显示 -->
        <el-form-item v-if="isTracking" :label="$t('message.ClientProjectMonitorSystemMonitorParmater.trackingStatus')">
          <div class="tracking-status">
            <el-tag type="success" size="small">
              <el-icon class="is-loading"><Loading /></el-icon>
              {{ $t('message.ClientProjectMonitorSystemMonitorParmater.trackingActive') }}
            </el-tag>
            <div class="remaining-time">
              {{ $t('message.ClientProjectMonitorSystemMonitorParmater.remainingTime') }}: 
              {{ formatRemainingTime() }}
            </div>
            <div class="current-interval" v-if="trackForm.updateMode === 'manual' && getCurrentInterval() > 0">
              {{ $t('message.ClientProjectMonitorSystemMonitorParmater.currentInterval') }}: {{ getCurrentInterval() }} {{ $t('message.ClientProjectMonitorSystemMonitorParmater.seconds') }}
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div class="dialog-footer">
        <!-- 停止追踪按钮 -->
        <el-button 
          v-if="isTracking" 
          type="danger" 
          @click="stopTracking"
          class="stop-btn"
        >
          <el-icon><SwitchButton /></el-icon>
          {{ $t("message.ClientProjectMonitorSystemMonitorParmater.stopTrack") }}
        </el-button>      
        
        <el-button 
          type="primary" 
          @click="confirmTrack"
          :disabled="isTracking || !isFormValid"
          :loading="partDataIsRollCallLoading"
        >
          {{ isTracking ? $t("message.ClientProjectMonitorSystemMonitorParmater.tracking") : $t("message.common.confirm") }}
        </el-button>
        <el-button @click="TrackDialogVisible = false">
          {{ $t("message.common.cancel") }}
        </el-button>
      </div>
    </div>
  </el-dialog>

  </div>        
</template>

<script setup>
import { 
  ref, 
  reactive, 
  computed, 
  defineExpose, 
  defineProps, 
  watch, 
  onMounted, 
  onUnmounted,
  nextTick 
} from 'vue' 
import { 
  ElMessage, 
  ElMessageBox, 
  ElTooltip
} from 'element-plus'
import { projectCollectionsDomainVars } from "@/api/ProjectManger";
import { useI18n } from "vue-i18n";
//import baseConfig from "@/public/config.json";
import { useSignalR } from "@/utils/signalR";
import { getToken } from "@/utils/auth";
import { heart } from "@/api/UserManager";
import { rollCall } from "@/api/DeviceManagement";
import ClientProjectHisData from "@/components/views/ClientProjectHisData.vue";
import ClientProjectRealTimePlot from "@/components/views/ClientProjectRealTimePlot.vue";
import { formatValueNoScientific } from "@/api/DeviceManagement";

const { t } = useI18n();

// SignalR 配置
//const url = `${baseConfig.apiBaseUrl}/subscriptionHub`;
const url = ref('');
const isRollCallLoading = ref(false); // 点名刷新加载状态
const partDataIsRollCallLoading = ref(false); // 点名刷新加载状态
const isQeuryLoading = ref(false);    // 查询加载状态
const isQeuryAllLoading = ref(false);    // 查询加载状态
let timer = null;
const refreshInterval = 5 *  60  * 1000; // 5分种订阅一次
const refreshHeartInterval = 5 * 60 * 1000; // 十分钟刷新一次数据
let heartTimer = null;
let trackTimer = null;
// 添加剩余时间定时器变量
let remainingTimeTimer = null;

// 追踪相关
const TrackDialogVisible = ref(false);
const isTracking = ref(false); // 新增：追踪状态
const trackingStartTime = ref(null); // 新增：追踪开始时间
const remainingTime = ref(0); // 新增：剩余时间
const trackForm = ref({
  updateMode: 'manual', // 'auto' 或 'manual'
  manualInterval: 5, // 手动更新间隔：1, 5, 10, 30, 0, -1(自定义)
  customIntervalValue: 60, // 自定义间隔值（秒）
  durationValue: 10, // 持续时间（分钟）
});



import { getConfig } from '@/utils/configTool';
// 3. 异步加载配置函数
async function loadConfig() {
  try {
      // 获取完整配置对象
    const config = await getConfig();
    // 解构使用
    // 4. 赋值 SignalR url
    url.value = config.signalRUrl;
    //console.log('SignalR 地址配置成功：', signalRUrl.value);
  } catch (error) {
    console.error('加载配置文件失败：', error); 
  }
}

// 时间校验+格式化函数
const formatValidTime = (time, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!isValidTime(time)) return t("message.ClientProjectMonitorSystemMonitorParmater.invalidTime");
  
  const date = new Date(typeof time === 'number' ? time : time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return format.replace('YYYY', year)
               .replace('MM', month)
               .replace('DD', day)
               .replace('HH', hours)
               .replace('mm', minutes)
               .replace('ss', seconds);
};

const isInvalidTitle=(title) =>{

      // if(title=="&&13_J")
      // {
      //           ElMessage.error(`${title} isInvalidTitle`);
      // }
      if (!title) return true;
      return /^&&\d+_/.test(title);
    }
    
const isValidTime = (time) => {
  // 空值、null、undefined 直接判定为不合法
  if (!time) return false;

  // 定义需要过滤的无效默认时间（支持不同格式）
  const invalidDefaultTimes = [
    '0001-01-01 00:00:00',
    '0001-01-01T00:00:00',
    '0001-01-01',
    '0001/01/01'
  ];

  // 如果是字符串，先检查是否是无效默认时间
  if (typeof time === 'string') {
    const trimmedTime = time.trim();
    // 匹配无效默认时间则直接返回不合法
    if (invalidDefaultTimes.some(invalid => trimmedTime.startsWith(invalid))) {
      return false;
    }
    // 空字符串判定为不合法
    if (!trimmedTime) return false;
    // 解析时间并校验
    const date = new Date(trimmedTime);
    return !isNaN(date.getTime());
  }

  // 处理时间戳（数字类型）
  if (typeof time === 'number') {
    const timestamp = Math.floor(time);
    // 0001-01-01对应的时间戳远小于0，直接判定为不合法
    return !isNaN(timestamp) && timestamp > 0 && timestamp < 4102444800000;
  }

  // 其他类型默认不合法
  return false;
};


// 表单验证
const isFormValid = computed(() => {
  if (trackForm.value.updateMode === 'manual') {
    if (trackForm.value.manualInterval === -1) {
      // 自定义间隔模式，需要验证自定义值
      return trackForm.value.customIntervalValue > 0 && trackForm.value.customIntervalValue <= 3600;
    }
  }
  return true;
});

 // 获取当前间隔时间
const getCurrentInterval = () => {
  if (trackForm.value.updateMode === 'auto') {
    return 0; // 自动模式返回0
  }
  
  if (trackForm.value.updateMode === 'manual') {
    if (trackForm.value.manualInterval === -1) {
      return trackForm.value.customIntervalValue; // 自定义间隔
    }
    return trackForm.value.manualInterval; // 预设间隔
  }
  return 0;
};
// 格式化剩余时间显示
const formatRemainingTime = () => {
  if (!isTracking.value || remainingTime.value <= 0) return '00:00';
  
  const minutes = Math.floor(remainingTime.value / 60);
  const seconds = remainingTime.value % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

// 存储键名
const getStorageKey = () => {
  return `selectedVariables_${props.projectId}_${props.collectionId}_${props.domainMenuId}_${props.domainId}`;
};

// ========== 分离的两个选择器功能 ==========

// 1. 查询数据选择器（用于查询数据、更新数据、分页）
const queryVarDevices = ref([]); // 
const queryVariableNames = ref([]); // 用于查询条件选择器的变量名数组

// 2. 图表选择器（用于历史数据和折线图，不存储）
const chartVarDevices = ref({}); // 格式: { deviceCode1: [var1, var2, ...], deviceCode2: [var3, var4, ...] }
const chartVariableNames = computed(() => {
  const allVarNames = [];
  for (const variables of Object.values(chartVarDevices.value)) {
    allVarNames.push(...variables.map(item => item.name));
  }
  return allVarNames;
});

// 获取查询用的选中变量（扁平化数组） 
 
// 获取查询用的选中变量 - 修正版本
const queryVariables = computed(() => {
  const result = [];
  
  console.log('构建查询参数 - chartVarDevices:', chartVarDevices.value);

  // 从 chartVarDevices 构建查询参数
  for (const [deviceCode, variables] of Object.entries(chartVarDevices.value)) {
    if (variables && variables.length > 0) {
      variables.forEach(variable => {
        result.push({
          varName: variable.name,        
          device_code: deviceCode // 使用设备代码作为 device_code
        });
      });
    }
  }
  
  console.log('queryVariables构建的查询参数:', result);
  return result;
});


// 检查变量是否被选中（图表选择器）
const isVariableSelected = (param) => {
  const deviceVars = chartVarDevices.value[param.deviceCode];
  return deviceVars && deviceVars.some(item => item.name === param.varName);
};

const {
  isConnected,  
  isReconnecting,
  reconnectAttempts,
  reconnectDelay,
  start,
  stop,
  invoke,
  on,
  off,
  onConnected,
} = useSignalR(url, {
  accessTokenFactory: () => getToken() || "",
  automaticReconnect: true,
});

// 重连消息
const reconnectMessage = computed(() => {
  return t("message.reaTimePlot.reconnecting", {
    attempts: reconnectAttempts.value,
    seconds: Math.round(reconnectDelay.value / 1000),
  });
});

// 定义 props
const props = defineProps({
  projectId: {
    type: [String, Number],
    required: true
  },
  businessId: {
    type: [String, Number],
    required: true
  },
  collectionId: {
    type: [String, Number],
    required: true
  },
  domainMenuId: {
    type: [String, Number],
    required: true
  },
  domainId: {
    type: [String, Number],
    required: true
  }
})

// 获取页面大小显示标签
const getPageSizeLabel = (size) => {
  if (size === 0) return  t("message.ClientProjectMonitorSystemMonitorParmater.paginationAll");
  return `${size} ` + t("message.ClientProjectMonitorSystemMonitorParmater.paginationPage");
};

// 查询参数：分页相关配置
const queryParams = reactive({
  pageNum: 1,
  pageSize: 0,
});

// 数据相关
const parameterData = ref({
  data: [
    {
      groupName: "",
      parameters: [
        { title: "", value: 0 }
      ]
    }
  ],
  totalCount: 1
});

// 加载状态控制
const isLoading = ref(false)
const hasLoaded = ref(false)

// 实时数据相关
const realTimeData = ref(new Map()); // 存储变量名到最新值的映射
const isSubscribed = ref(false);

const hisDataDialogVisible = ref(false);
const hisDialogTitle = ref('');

const realTimePlotDialogVisible = ref(false); 
const realTimePlotTitle = ref('');

// ========== 报警状态相关方法 ==========
// 根据变量值判断报警状态
const getAlarmStatus = (param) => {
  if (param.value === 0) return 'normal';  
  
  const value = formatValueNoScientific(param.value,param.mult,param.varDecimal);  
  // 这里可以根据实际业务逻辑判断状态
  if (Number(value) !== 0) return 'alarm';  
  return 'normal';
};

// 状态样式方法
const getStatusClass = (status) => {
  const statusClasses = {
    'normal': 'status-normal',
    'alarm': 'status-alarm',
    'locked': 'status-locked',
    'comm-error': 'status-comm-error'
  };
  return statusClasses[status] || 'status-normal';
};

const getStatusText = (status,param) => {
  const statusTexts = {
    'normal': t('message.ClientDeviceMonitorSystemSettingsAlarmReset.normal'),
    'alarm': t('message.ClientDeviceMonitorSystemSettingsAlarmReset.alarm'),
    'locked': t('message.ClientDeviceMonitorSystemSettingsAlarmReset.locked'),
    'comm-error': t('message.ClientDeviceMonitorSystemSettingsAlarmReset.comm-error')
  };
  
  const value = formatValueNoScientific(param.value,param.mult,param.varDecimal);  

  return  (Number(value) == 0 ? statusTexts[status]  :statusTexts[status] + ':'+  value) || '正常';
};

// 重置操作
const handleReset = async (param) => {
  try {

    await ElMessageBox.confirm(
      t("message.ClientDeviceMonitorSystemSettingsAlarmReset.confirmRetset", {
        title: param.title        
      }),
      t("message.ClientDeviceMonitorSystemSettingsAlarmReset.confirmReset"),
      {
        confirmButtonText: t("message.common.confirm"),
        cancelButtonText: t("message.common.cancel"),
        type: 'warning'
      }
    );

    await handleSetValue(param);
    
  } catch (error) {
    if (error !== 'cancel') {
      console.error('重置操作失败:', error);    
    }
  }
};

// 新增：发送当前变量值的方法
const sendCurrentVariableValue = async (param) => {
  try {
    if (!isConnected.value) {
      ElMessage.error(t("message.ClientDeviceMonitorSystemDebugHostDebug.connectError"));
      return false;
    }

    const token = getToken();
    
    // 获取变量的当前值（如果有实时值则使用，否则使用默认值）
    const currentValue = param.defaultValue || 0;
    
    // 考虑系数和精度
    const adjustedValue = formatValueNoScientific(currentValue, param.mult, param.varDecimal);
    
    const params = [{
      token: token,
      deviceCode: param.deviceCode, // 使用当前变量的设备代码
      imei: undefined,
      Dir: "Down",
      type: 4,
      timer: new Date().toISOString(),
      priority: 1,
      r_data: [{name: param.varName}], // 不需要读取，直接写入
      w_data: [{
        name: param.varName,
        value: Number(adjustedValue) / (param.mult || 1)
      }],
    }];

    await rollCall(params);
    
    console.log(`变量 ${param.varName} 设置成功，值: ${adjustedValue}`);
    return true;
    
  } catch (error) {
    console.error('设置当前变量值失败:', error);
    throw error;
  }
};


const handleSetValue = async (param) => {
  try {
    param.isSetting = true;
     
    if (!isConnected.value) {
      ElMessage.error(t("message.ClientDeviceMonitorSystemDebugHostDebug.connectError"));
      return;
    }

    const token = getToken();
    
 

    // // 检查是否有联动变量
    // if (!param.linkageVars || param.linkageVars.length === 0) {
    //   sendCurrentVariableValue(param);
    //   ElMessage.warning(t("message.ClientDeviceMonitorSystemSettingsAlarmReset.noLinkageVars", {
    //     name: param.varName        
    //   }));
    //   return;
    // }

    // 确认是否要给当前变量发值
    if (!param.linkageVars || param.linkageVars.length === 0) {
      try {
        await ElMessageBox.confirm(
          t("message.ClientDeviceMonitorSystemSettingsAlarmReset.noLinkageVars", {
             name: param.varName            
          }),
          "",
          {
            confirmButtonText: t("message.common.confirm"),
            cancelButtonText: t("message.common.cancel"),
            type: 'warning'
          }
        );
        
        // 用户确认，发送当前变量值
        await sendCurrentVariableValue(param);        
        // 点名后重新订阅实时数据
        await startRealTimeSubscription();
        return;
        
      } catch (confirmError) {
        if (confirmError !== 'cancel') {
          throw confirmError;
        }
        // 用户取消，直接返回
        return;
      }
    }


    // 检查设备代码是否匹配
    for (let i = 0; i < param.linkageVars.length; i++) {
      if (param.deviceCode !== param.linkageVars[i].target_device_code) {        
        ElMessage.warning(t("message.ClientDeviceMonitorSystemSettingsAlarmReset.errorDeviceCode"));
        return;
      }
    }
 

    // 按 target_device_code 分组
    const deviceGroups = {};
    param.linkageVars.forEach(linkageVar => {
      const deviceCode = linkageVar.target_device_code;
      if (!deviceGroups[deviceCode]) {
        deviceGroups[deviceCode] = [];
      }
      deviceGroups[deviceCode].push(linkageVar);
    });

    // 调试信息：显示分组情况
    console.log('按设备分组结果:', deviceGroups);
    //ElMessage.error(`联动变量分组: ${Object.keys(deviceGroups).length} 个设备`);

    let successCount = 0;

    // 为每个设备分别处理
    for (const [deviceCode, linkageVars] of Object.entries(deviceGroups)) {
      //  ElMessage.error(`处理设备 ${deviceCode}, 变量数量: ${linkageVars.length}`);
      // 将同一设备的联动变量按每5个一组分块
      const chunkSize = 5;
      const chunks = [];
      for (let i = 0; i < linkageVars.length; i += chunkSize) {
        chunks.push(linkageVars.slice(i, i + chunkSize));
      }

      // 依次执行该设备的每个批次
      for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
        const chunk = chunks[chunkIndex];
        
        // 调试信息：显示当前批次信息
       // ElMessage.error(`设备 ${deviceCode} 批次 ${chunkIndex + 1}/${chunks.length}: ${chunk.length} 个变量`);
        const params = [{
          token: token,
          deviceCode: deviceCode, // 使用目标设备的 deviceCode
          imei: undefined,
          Dir: "Down",
          type: 4,
          timer: new Date().toISOString(),
          priority: 1,
          r_data: [],
          w_data: [],
        }];

        // 添加读取变量（源变量）- 如果需要的话
        params[0].r_data.push({ name: param.varName });
        
        // 添加当前批次的所有写入变量
        chunk.forEach(linkageVar => {
          params[0].w_data.push({ 
            name: linkageVar.target_var_name, 
            value: (linkageVar.target_var_value  / (linkageVar.mult ?? 1))
          });
        });

        await rollCall(params);
        
        successCount += chunk.length;
        console.log(`设备 ${deviceCode} 批次 ${chunkIndex + 1}/${chunks.length} 执行成功，包含 ${chunk.length} 个联动变量`);
        
        // 可选：在批次之间添加小延迟
        if (chunkIndex < chunks.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }
    }

    ElMessage.success(
      t("message.ClientDeviceMonitorSystemSettingsAlarmReset.reSetSuccess", {
        title: param.title,
        count: successCount
      })
    );

    // 点名后重新订阅实时数据
    await startRealTimeSubscription();

  } catch (error) {
    if (error !== 'cancel') {
      console.error('设置参数值失败:', error);
      ElMessage.error(
        t("message.ClientDeviceMonitorSystemSettingsAlarmReset.resetFailed", {
          title: param.title,
          error: error.message
        })
      );
    }
  } finally {
    param.isSetting = false;
  }
};
 

// 模拟 C# StringComparer.Ordinal 排序（按 Unicode 编码纯字节比较）
const nameInfoCompare = (nameA, nameB) => {  
  return nameA.localeCompare(nameB, 'en-US', {
    sensitivity: 'variant',
    numeric: false,
    caseFirst: 'upper',
    usage: 'sort'
  });
};

// 扁平化数据
const flatData = computed(() => {
  if (!parameterData.value?.data?.length) return [];
  
  const allData = parameterData.value.data.flatMap(group => 
    (group.parameters || []).map(param => ({
      ...param,
      companyId: group.companyId,
      groupName: group.groupName,
      groupSort: group.groupSort || 0
    }))
  );

  // 按原来的排序逻辑
  return allData.sort((a, b) => {
    if (a.groupSort !== b.groupSort) return a.groupSort - b.groupSort;
    if (a.groupName !== b.groupName)  nameInfoCompare(a.groupName ,b.groupName);
    if (a.varSort !== b.varSort) return a.varSort - b.varSort;
    return  nameInfoCompare(a.title ,b.title);
  });
});

// 按有无重置功能排序的数据
// 按有无重置功能排序的数据
const sortedFlatData = computed(() => {
  const data = [...flatData.value];
  
  // 按有无重置功能排序：无重置的在前，有重置的在后
  return data.sort((a, b) => {
    /*const aHasReset = a.varCmdSwitch === 1;
    const bHasReset = b.varCmdSwitch === 1;
    
    if (aHasReset && !bHasReset) return 1;
    if (!aHasReset && bHasReset) return -1;
    */
    // 如果重置功能相同，保持原来的排序
    //if (a.groupSort !== b.groupSort) return a.groupSort - b.groupSort;
    //if (a.groupName !== b.groupName)  nameInfoCompare(a.groupName ,b.groupName);
    if (a.varSort !== b.varSort) return a.varSort - b.varSort;
    return  nameInfoCompare(a.title ,b.title);
  });
});

// const sortedFlatData = computed(() => {
//   const data = [...flatData.value];
  
//   // 按有无重置功能排序：无重置的在前，有重置的在后
//   return data.sort((a, b) => {
//     const aHasReset = a.varCmdSwitch === 1;
//     const bHasReset = b.varCmdSwitch === 1;
    
//     if (aHasReset && !bHasReset) return 1;
//     if (!aHasReset && bHasReset) return -1;
    
//     // 如果重置功能相同，保持原来的排序
//     if (a.groupSort !== b.groupSort) return a.groupSort - b.groupSort;
//     if (a.groupName !== b.groupName)  nameInfoCompare(a.groupName ,b.groupName);
//     if (a.varSort !== b.varSort) return a.varSort - b.varSort;
//     return  nameInfoCompare(a.title ,b.title);
//   });
// });

// ========== 图表选择器处理（块上的选择） ==========
const handleVariableSelection = (param, checked) => {
  const { deviceCode, varName, title, companyId,mult,varDecimal } = param;
  
  if (checked) {
    // 添加变量到图表选择器
    if (!chartVarDevices.value[deviceCode]) {
      chartVarDevices.value[deviceCode] = [];
    }
    
    // 检查变量是否已存在
    const existingVar = chartVarDevices.value[deviceCode].find(item => item.name === varName);
    if (!existingVar) {
      chartVarDevices.value[deviceCode].push({
        name: varName,
        title: title || varName,
        mult: mult || 1,
        var_decimal: varDecimal || 0,
        companyId: companyId || 0
      });
    }
  } else {
    // 从图表选择器中移除变量
    if (chartVarDevices.value[deviceCode]) {
      const index = chartVarDevices.value[deviceCode].findIndex(item => item.name === varName);
      if (index > -1) {
        chartVarDevices.value[deviceCode].splice(index, 1);
        // 如果设备没有变量了，删除设备条目
        if (chartVarDevices.value[deviceCode].length === 0) {
          delete chartVarDevices.value[deviceCode];
        }
      }
    }
  }
  
  console.log('图表选择的变量设备分组:', chartVarDevices.value);
};


// 保存查询变量到本地存储
const saveQueryVariables = () => {
  try {
    const storageKey = getStorageKey();
    localStorage.setItem(storageKey, JSON.stringify(queryVariables.value));
    console.log('查询变量选择已保存到本地存储:',  queryVariables.value);
  } catch (error) {
    console.error('保存查询变量选择失败:', error);
  }
};


const loadQueryVariables = () => {
  try {
    const storageKey = getStorageKey();
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed)) {        
        console.log('从本地存储加载变量选择:', parsed);
        return parsed;
      }
    }
  } catch (error) {
    console.error('加载变量选择失败:', error);
  }
  return null;
};
 

// 显示历史数据
const showHistoryData = () => {
  if (Object.keys(chartVarDevices.value).length === 0) {
    ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.selectVariableFirst"));
    return;
  }

  const totalVars = chartVariableNames.value.length;  
  if (totalVars >5) {
    ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.maxFiveVariables"));
    return;
  }
  
  hisDialogTitle.value = t("message.ClientProjectMonitorSystemMonitorParmater.historyDataTitle", { count: totalVars });  
  hisDataDialogVisible.value = true;
};

// 显示实时折线
const showRealTimeChart = () => {
  if (Object.keys(chartVarDevices.value).length === 0) {
    ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.selectVariableFirst"));
    return;
  }
  const totalVars = chartVariableNames.value.length;
  realTimePlotTitle.value = t("message.ClientProjectMonitorSystemMonitorParmater.realTimePlotTitle", { count: totalVars });  
  realTimePlotDialogVisible.value = true;
};

//使用查询变量
const loadDefaultParameters = async (varNames = null) => {
  if (isLoading.value) return;
  
  try {
    isLoading.value = true;
    
    let nameVarFilters = undefined;
    let deviceCodeNamesFilters = undefined;

    if (varNames && varNames.length > 0) {
        nameVarFilters = varNames.map(item => item.varName).filter(Boolean);
        
        // 构建 deviceCodeNames 参数
        deviceCodeNamesFilters = varNames.map(item => ({
            deviceCode: item.device_code || '',
            name: item.varName || ''
        })).filter(item => item.deviceCode && item.name); // 确保 deviceCode 和 name 都不为空
        
        console.log('变量过滤器:', nameVarFilters);
        console.log('设备变量组合过滤器:', deviceCodeNamesFilters);
    } else {
        console.log('没有变量过滤器，查询全部');
    }

    const params = { 
      projectId: props.projectId,      
      businessId:props.businessId,
      collectionsId: props.collectionId,
      domainParentId: props.domainMenuId,
      domainId: props.domainId, 
      companyId: 0,
      groupNames:undefined,
      names: undefined, // 直接使用过滤后的变量名数组      
      name: undefined,       
      display_name: undefined,
      deviceCodeNames:deviceCodeNamesFilters,
      pageNum: queryParams.pageNum,
      pageSize: queryParams.pageSize ===0 ? 100000 : queryParams.pageSize,
    };

    console.log('API请求参数:', JSON.stringify(params, null, 2));

    const res = await projectCollectionsDomainVars(params);
    if(!res.success) {
      ElMessage.error(res?.msg);  
      return;
    }    
    
    if (!res.data.list || res.data.list.length === 0) {
      parameterData.value = { data: [], totalCount: 0 };
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noVariables"));
      return;
    }
    
    parameterData.value = convertToParameterData(res);
    queryParams.totalCount = parameterData.value.totalCount;
    hasLoaded.value = true;
    //查询完成后执行一次订阅
    await startRealTimeSubscription();
    console.log('查询结果:', {
      总条数: queryParams.totalCount,
      返回数据条数: parameterData.value.data.reduce((total, group) => total + group.parameters.length, 0)
    });
    
  } catch (error) {
    console.error('加载业务选项失败:', error);    
    ElMessage.error(error.message || t("message.ClientProjectMonitorSystemMonitorParmater.loadFail"));
  } finally {
    isLoading.value = false;
  }
}

// 启动实时数据订阅
const startRealTimeSubscriptionAll = async () => {
  if (!isConnected.value) {
    console.log('SignalR 未连接，等待连接...');
    return;
  }
  
  // 按设备代码分组变量
  const deviceVariableMap = getDeviceVariableMap();
  if (deviceVariableMap.size === 0) {
    console.log('没有可订阅的变量');
    return;
  }
  
  try {
    const token = getToken();
    
    // 为每个设备创建订阅请求
    const subscriptionPromises = [];
    
      const ClientExternParameterModel = {
          projectId: Number(props.projectId),
          collectionsId: Number(props.collectionId),     
          deviceId: 0,   
          domainId: Number(props.domainId),
      }
      
      const params = {
        token: token,
        deviceCode: "",
        imei: null,
        Dir: "d",
        type: 5, // 按项目业务订阅
        timer: new Date().toISOString(),
        priority: 1,
        e_data: ClientExternParameterModel,
      };
      
      const jsonString = JSON.stringify(params);
      subscriptionPromises.push(
        invoke("RequestData", jsonString)
          .then(() => {
            console.log(`订阅成功`);
          })
          .catch(error => {
            console.error(`订阅失败:`, error);
            throw error;
          })
      );
    
    // 并行发送所有订阅请求
    await Promise.all(subscriptionPromises);
    isSubscribed.value = true;
    console.log('所有设备实时数据订阅已启动', deviceVariableMap);
    
  } catch (error) {
    console.error('启动实时订阅失败:', error);
  }
}

// 启动实时数据订阅
const startRealTimeSubscription = async () => {
  if (!isConnected.value) {
    console.log('SignalR 未连接，等待连接...');
    return;
  }
  
  // 按设备代码分组变量
  const deviceVariableMap = getDeviceVariableMap();
  if (deviceVariableMap.size === 0) {
    console.log('没有可订阅的变量');
    return;
  }
  
  //如果查询超过30或者没有查询，则用全部订阅
  if(queryVariables.value.length<=0 || queryVariables.value.length>30)
  {
    await startRealTimeSubscriptionAll();
    return;
  }

  try {
    const token = getToken();
    
    // 为每个设备创建订阅请求
    const subscriptionPromises = [];
    
    for (const [deviceCode, variableNames] of deviceVariableMap) {
      if (variableNames.length === 0) continue;
      
      const params = {
        token: token,
        deviceCode: deviceCode,
        imei: null,
        Dir: "d",
        type: 1, // 实时数据订阅
        timer: new Date().toISOString(),
        priority: 1,
        r_data: variableNames.map(name => ({ name })),
      };
      
      const jsonString = JSON.stringify(params);
      subscriptionPromises.push(
        invoke("RequestData", jsonString)
          .then(() => {
            console.log(`设备 ${deviceCode} 订阅成功，变量数量: ${variableNames.length}`);
          })
          .catch(error => {
            console.error(`设备 ${deviceCode} 订阅失败:`, error);
            throw error;
          })
      );
    }
    
    // 并行发送所有订阅请求
    await Promise.all(subscriptionPromises);
    isSubscribed.value = true;
    console.log('所有设备实时数据订阅已启动', deviceVariableMap);
    
  } catch (error) {
    console.error('启动实时订阅失败:', error);
  }
}

// 按设备代码分组变量（使用查询变量）
const getDeviceVariableMap = () => {
  const deviceMap = new Map();
  
  // 从 parameterData.value 中提取设备变量映射
  if (parameterData.value?.data?.length > 0) {
    // 遍历所有分组和参数
    parameterData.value.data.forEach(group => {
      if (group.parameters?.length > 0) {
        group.parameters.forEach(param => {
          const deviceCode = param.deviceCode;
          const varName = param.varName;
          
          if (deviceCode && varName) {
            if (!deviceMap.has(deviceCode)) {
              deviceMap.set(deviceCode, []);
            }
            // 去重处理
            const currentVars = deviceMap.get(deviceCode);
            if (!currentVars.includes(varName)) {
              currentVars.push(varName);
            }
          }
        });
      }
    });
  }
  
  console.log('设备变量映射:', Object.fromEntries(deviceMap));
  return deviceMap;
}

// 停止实时数据订阅
const stopRealTimeSubscription = async () => {
  if (!isConnected.value || !isSubscribed.value) return;
  
  try {
    
    const token = getToken();
    const deviceVariableMap = getDeviceVariableMap();
    
    const releasePromises = [];
    
    for (const [deviceCode] of deviceVariableMap) {
      const params = {
        token: token,
        deviceCode: deviceCode,
        imei: null,
        Dir: "d",
        type: 1,
        priority: 1,
        timer: new Date().toISOString(),
        r_data: [], // 空数组表示取消该设备的所有订阅
      };
      
      const jsonString = JSON.stringify(params);
      
      releasePromises.push(
        invoke("ReleaseData", jsonString)
          .then(() => {
            console.log(`设备 ${deviceCode} 取消订阅成功`);
          })
          .catch(error => {
            console.error(`设备 ${deviceCode} 取消订阅失败:`, error);
          })
      );
    }
    
    // 并行发送所有取消订阅请求
    await Promise.all(releasePromises);
    isSubscribed.value = false;
    console.log('所有设备实时数据订阅已停止');
    
  } catch (error) {
    console.error('停止实时订阅失败:', error);
  }
}

// 处理实时数据消息
// 处理实时数据消息
const handleRealTimeData = (message) => {
  try {
    const receivedData = JSON.parse(message);
    console.log('收到实时数据:', {
      deviceCode: receivedData.DeviceCode,
      varsCount: receivedData.Vars?.length || 0,
      time: receivedData.time
    });

    if (isTracking.value == true && trackForm.value.updateMode === 'manual' && trackForm.value.manualInterval === 0) {
      console.log('停止实时数据更新');
      return;
    }

    if (receivedData.Vars && Array.isArray(receivedData.Vars)) {
      let hasUpdate = false;
      
      receivedData.Vars.forEach(variable => {
        if (variable && variable.Name && variable.Error === 0) {
          // 创建唯一的键：deviceCode + variableName
          const uniqueKey = `${receivedData.DeviceCode}_${variable.Name}`;
          
          // 更新实时数据 Map
          realTimeData.value.set(uniqueKey, {
            value: variable.Value?.toString() || '0',
            deviceCode: receivedData.DeviceCode,
            varName: variable.Name,
            timestamp: receivedData.time.replace('T',' ')
          });
          
          // 更新 parameterData 中的值          
          updateParameterValue(receivedData.DeviceCode, variable.Name, variable.Value?.toString() || '0',receivedData.time.replace('T',' '));
          
          hasUpdate = true;
          
          console.log(`更新变量: ${uniqueKey} = ${variable.Value}`);
        }
      });
      
      // 只有有更新时才触发界面刷新
      if (hasUpdate) {
        // 这里不需要手动更新 parameterData.value，因为 updateParameterValue 已经修改了原始数据
        // 只需要触发响应式更新
        parameterData.value = { ...parameterData.value };
      }
    }
  } catch (error) {
    console.error('处理实时数据错误:', error);
    ElMessage.error(`${error.message}`);
  }
}

// 更新 parameterData 中变量值的函数
const updateParameterValue = (deviceCode, varName, newValue,updateAt) => {
  if (!parameterData.value?.data?.length) return;
  
  // 遍历所有分组和参数，找到匹配的变量并更新值
  for (let i = 0; i < parameterData.value.data.length; i++) {
    const group = parameterData.value.data[i];
    if (group.parameters && group.parameters.length > 0) {
      for (let j = 0; j < group.parameters.length; j++) {
        const param = group.parameters[j];
        if (param.deviceCode === deviceCode && param.varName === varName) {
          // 直接修改对象属性，Vue会检测到变化
          param.value = newValue;
          param.updateAt = updateAt;
          console.log(`已更新变量值: ${deviceCode} - ${varName} = ${newValue}-${updateAt}`);
          break;
        }
      }
    }
  }
}
// 数据转换方法
const convertToParameterData = (res) => {
  if (!res?.data?.list) {
    return {
      data: [],
      totalCount: 0
    };
  }

  return {
    data: res.data.list.map(item => ({
      groupName: item.group_name || '未分组',
      groupSort: item.group_sort || 0,
      companyId: item.company_id || 0,
      parameters: (item.list_parm || []).map(param => ({
        varName: param.var_name,
        title: param.display_name,
        value: param.var_current_value?.toString() || '0',
        unit: param.var_unit?.toString() || '',
        varSort: param.var_sort || 0,
        deviceCode: param.device_code || '',
        updateAt: '---',//param.update_at.replace('T', ' ')  || '',
        description:param.description,
        defaultValue: param.var_default_value,
        mult :        param.mult ||  1,
        minimum :     param.minimum,
        maximum  :    param.maximum,
        varDecimal : param.var_decimal,
        // 添加报警重置相关字段
        varCmdSwitch: Number(param.var_cmd_switch) || 0,
        linkageVars: param.projectInfoBindLinkages || [],
      })).filter(param => param.title !== '未知参数')
    })).filter(group => group.parameters.length > 0),
    totalCount: res.data.totalCount || 0
  };
};

// 获取所有变量的名称列表
const getVariableNames = () => {
  const variableNames = new Set();
  
  if (!parameterData.value?.data?.length) return [];
  
  parameterData.value.data.forEach(group => {
    group.parameters.forEach(param => {
      if (param.varName) {
        variableNames.add(param.varName);
      }
    });
  });
  
  return Array.from(variableNames);
}

//先查选择的数据
const getDeviceVariableMapFilter = () => 
{ 
     let deviceVariableMap;
    
    if (chartVariableNames.value.length > 0) {
      // 如果有图表选择的变量，构建对应的设备变量映射
      deviceVariableMap = new Map();
      
      // 从 chartVarDevices 构建设备变量映射
      for (const [deviceCode, variables] of Object.entries(chartVarDevices.value)) {
        if (variables && variables.length > 0) {
          const varNames = variables.map(item => item.name);
          deviceVariableMap.set(deviceCode, varNames);
        }
      }
    }  
  return deviceVariableMap;
}

// 打开追踪功能
const handleTrack = () => {
  
  if (isTracking.value) {
    // 如果正在追踪，点击停止追踪
    //stopTracking();
    //return;
  }
  
  if (!isConnected.value) {
    ElMessage.error(t("message.ClientProjectMonitorSystemMonitorParmater.connectError"));
    return;
  }
  
  // 获取当前页面的所有变量
  const currentVariables = getVariableNames();
  if (currentVariables.length === 0) {
    ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noVariables"));
    return;
  }

  // 如果没有选择变量，弹出确认提示
  // if (chartVariableNames.value.length === 0) {
  //   ElMessageBox.confirm(
  //     t("message.ClientProjectMonitorSystemMonitorParmater.noVariablesConfirm"),
  //     t("message.ClientProjectMonitorSystemMonitorParmater.confirmTitle"),
  //     {
  //       confirmButtonText: t("message.common.confirm"),
  //       cancelButtonText: t("message.common.cancel"),
  //       type: 'warning',
  //     }
  //   ).then(() => {
  //     // 用户确认，继续打开追踪对话框
  //     TrackDialogVisible.value = true;
  //   }).catch(() => {
  //     // 用户取消，不执行任何操作
  //     console.log('用户取消追踪操作');
  //   });
  //   return;
  // }

  TrackDialogVisible.value = true;
};

// 停止追踪
const stopTracking = () => {
  
  if (trackTimer) {    
    clearInterval(trackTimer);
    trackTimer = null;
  }
  
  if (remainingTimeTimer) {
    clearInterval(remainingTimeTimer);
    remainingTimeTimer = null;
  }
  partDataIsRollCallLoading.value = false;
  isTracking.value = false;
  trackingStartTime.value = null;
  remainingTime.value = 0;
  
  //ElMessage.success(t("message.ClientProjectMonitorSystemMonitorParmater.trackingStopped"));
};

 
// 更新剩余时间
const updateRemainingTime = () => {
  if (isTracking.value && trackingStartTime.value) {
    const elapsed = Math.floor((Date.now() - trackingStartTime.value) / 1000);
    const totalDuration = trackForm.value.durationValue * 60;
    remainingTime.value = Math.max(0, totalDuration - elapsed);
    
    if (remainingTime.value <= 0) {
      stopTracking();
    }
  }
};

//全部更新
const handldUpdateAll = async () => {
  try {
    if (!isConnected.value) {
      ElMessage.error(t("message.ClientProjectMonitorSystemMonitorParmater.connectError"));
      return;
    } 
    const currentVariables = getVariableNames();
    if (currentVariables.length === 0) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noVariables"));
      return;
    }
    // 如果选了数据就用选择的，
    const deviceVariableMap = chartVariableNames.value.length > 0 ? getDeviceVariableMapFilter() : getDeviceVariableMap();
    
    if (deviceVariableMap.size === 0) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noDevices"));
      return;
    } 
    isRollCallLoading.value = true;    
    // 立即执行一次数据获取
    await rollCallClick(deviceVariableMap);
    isRollCallLoading.value = false;    
 
  } catch (error) {
    console.error("启动实时跟踪失败:", error);  
    isRollCallLoading.value = false; 
  } 
}

// 开始追踪
const confirmTrack = async () => {
  if (trackTimer) {
    clearInterval(trackTimer);
    trackTimer = null;
  }

  try {
    if (!isConnected.value) {
      ElMessage.error(t("message.ClientProjectMonitorSystemMonitorParmater.connectError"));
      return;
    }
    
    // 表单验证
    if (!isFormValid.value) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.invalidInterval"));
      return;
    }
    
    // 获取当前页面的所有变量
    const currentVariables = getVariableNames();
    if (currentVariables.length === 0) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noVariables"));
      return;
    }

    // 如果选了数据就用选择的
    const deviceVariableMap = chartVariableNames.value.length > 0 ? getDeviceVariableMapFilter() : getDeviceVariableMap();
    
    if (deviceVariableMap.size === 0) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noDevices"));
      return;
    }

    // 设置追踪状态
    partDataIsRollCallLoading.value = true;
    isTracking.value = true;
    trackingStartTime.value = Date.now();
    remainingTime.value = trackForm.value.durationValue * 60;

    // 启动剩余时间更新定时器
    remainingTimeTimer = setInterval(updateRemainingTime, 1000);

    // 立即执行一次数据获取
    await rollCallClick(deviceVariableMap);
    
    // 根据更新模式设置定时器
    if (trackForm.value.updateMode === 'manual') {
      const interval = getCurrentInterval();
      if (interval > 0) {
        // 手动模式且有更新间隔
        trackTimer = setInterval(async () => {
          try {
            await rollCallClick(deviceVariableMap);        
          } catch (error) {
            console.error("定时数据获取失败:", error);
            stopTracking();        
            ElMessage.error(t("message.reaTimePlot.dataProcessError"));
          }
        }, interval * 1000);
      }
      // 如果 interval = 0，则不设置定时器（不更新）
    } else if (trackForm.value.updateMode === 'auto') {
      // 自动模式 - 基于设备上传频率，这里可以设置一个较短的检查间隔
      trackTimer = setInterval(async () => {
        try {
          // 自动模式下可以更频繁地检查数据更新
          await startRealTimeSubscription();
        } catch (error) {
          console.error("自动更新检查失败:", error);
        }
      }, 2000); // 2秒检查一次
    }

    // 设置自动停止时间
    const durationMs = trackForm.value.durationValue * 60 * 1000;
    setTimeout(() => {
      if (isTracking.value) {
        stopTracking();        
        ElMessage.success(t("message.reaTimePlot.trackingCompleted"));
      }
    }, durationMs);

    TrackDialogVisible.value = false;
    ElMessage.success(t("message.ClientProjectMonitorSystemMonitorParmater.trackingStarted"));
  } catch (error) {
    console.error("启动实时跟踪失败:", error);
    stopTracking();
  } finally {
    partDataIsRollCallLoading.value = false;
  }
};
// 优化后的点名刷新方法
const rollCallClick = async (deviceVariableMap) => {
  try {
//    isRollCallLoading.value = true;    
    const token = getToken();    
    if (deviceVariableMap.size === 0) {
      return;
    }

    // 为每个设备发送点名请求
    const rollCallPromises = [];

    for (const [deviceCode, variableNames] of deviceVariableMap) {
      if (variableNames.length === 0) continue;
      
      // 将变量名按每5个分组
      const variableChunks = chunkArray(variableNames, 5);
      
      // 为每个变量包创建请求
      for (let i = 0; i < variableChunks.length; i++) {
        const chunk = variableChunks[i];
        
        const params = {
          token: token,
          deviceCode: deviceCode,
          imei: undefined,
          Dir: "Down",
          type: 4, // 点名类型
          timer: new Date().toISOString(),
          priority: 1,
          r_data: chunk.map(name => ({ name })),
          w_data: [],
        };
        
        rollCallPromises.push(
          rollCall([params])
            .then(() => {
              console.log(`设备 ${deviceCode} 第${i + 1}/${variableChunks.length}包点名成功，变量数量: ${chunk.length}`);
            })
            .catch(error => {
              console.error(`设备 ${deviceCode} 第${i + 1}包点名失败:`, error);
              throw error;
            })
        );
        
        // 可选：添加延迟避免请求过于密集
        if (i < variableChunks.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
    }
    
    // 并行发送所有点名请求
    await Promise.all(rollCallPromises);
    
    // 点名后重新订阅实时数据
    await startRealTimeSubscription();
    
  } catch (error) {
    if (error !== 'cancel') {
      console.error('点名操作失败:', error);
    }
  } finally {
   // isRollCallLoading.value = false;
  }
}

const handleQueryAllDataClick = async () => {
  try {    
    isQeuryAllLoading.value = true;
    queryParams.pageNum = 1;

    saveQueryVariables();
    // 清除所有选中的复选框 - 使用深拷贝确保响应式更新
    chartVarDevices.value = JSON.parse(JSON.stringify({}));    
    // 等待DOM更新
    await nextTick();
    await loadDefaultParameters();
        
  } catch (error) {
    console.error('查询操作失败:', error);
  } finally {
    isQeuryAllLoading.value = false;
  }
}

// 查询数据方法（使用查询变量）
const handleQueryDataClick = async () => {
  try {    
    isQeuryLoading.value = true;
    queryParams.pageNum = 1;
    saveQueryVariables();
    if(queryVariables.value.length<=0)
    {
      return;
    }
    await loadDefaultParameters(queryVariables.value);
        
  } catch (error) {
    console.error('查询操作失败:', error);
  } finally {
    isQeuryLoading.value = false;
  }
}

// 辅助函数：将数组按指定大小分块
const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

// 分页事件
const handleSizeChange = async(newSize) => {
  queryParams.pageSize =  newSize;
  queryParams.pageNum = 1;
  await loadDefaultParameters(queryVariables.value);
};

const handleCurrentChange = async (newPage) => {
  queryParams.pageNum = newPage;
  await loadDefaultParameters(queryVariables.value);
  document.querySelector('.data-grid')?.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// 标签切换事件
const handleTabChange = async (name) => {
  console.log('切换到标签:', name);
  queryParams.pageNum = 1;
  await loadDefaultParameters(queryVariables.value);
};

// 连接成功回调
const unsubscribeConnected = onConnected(async () => {
  console.log('SignalR 连接成功');
  if (hasLoaded.value) {
    await startRealTimeSubscription();
  }
});

// 监听 props 变化
watch(
  [
    () => props.projectId,
    () => props.collectionId, 
    () => props.domainMenuId,
    () => props.domainId
  ],
  async (newValues, oldValues) => {
    const [newProjectId, newCollectionId, newDomainMenuId, newDomainId] = newValues;
    const [oldProjectId, oldCollectionId, oldDomainMenuId, oldDomainId] = oldValues || [];
    
    if (newProjectId && newCollectionId && newDomainMenuId && newDomainId) {
      const isPropsChanged = 
        newProjectId !== oldProjectId || 
        newCollectionId !== oldCollectionId || 
        newDomainMenuId !== oldDomainMenuId || 
        newDomainId !== oldDomainId;
      
      if (!oldValues || isPropsChanged) {
        try {
         // 1. 清空图表选择的变量（复选框选中状态）
          chartVarDevices.value = {};
          
          // 2. 清空查询变量
          queryVarDevices.value = [];
          queryVariableNames.value = [];
          
          // 3. 清除本地存储的变量选择
          const storageKey = getStorageKey();
          localStorage.removeItem(storageKey);
          
          // 停止旧的订阅
          await stopRealTimeSubscription();
          realTimeData.value.clear();
          
          // 重新加载保存的查询变量选择
                    
          // 重新加载保存的查询变量选择
          const parms =  loadQueryVariables();          
          await loadDefaultParameters(parms);

        } catch (error) {
          console.error('监听props变化时加载数据失败:', error);
          ElMessage.error(error);
        }
      }
    }
  },
  { immediate: true }
);

// 开始自动刷新
const startAutoRefresh = () => {
  stopAutoRefresh();
  //首次订阅
  startRealTimeSubscription();

  timer = setInterval(() => {    
      startRealTimeSubscription();    
  }, refreshInterval);
  //启动心跳
  heartTimer = setInterval(() => {
    heart();
  }, refreshHeartInterval);
};

// 停止自动刷新
const stopAutoRefresh = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }

  if (heartTimer) {
    clearInterval(heartTimer);
    heartTimer = null;
  }
};

// 生命周期
onMounted(async () => {
  try {
    await loadConfig();
    await start();
    on("ReceiveMessage", handleRealTimeData);
    startAutoRefresh();

    
    await loadDefaultParameters();
    // // 首先加载保存的查询变量选择
    // const parms = loadQueryVariables();
    // // 使用查询变量进行初始加载
    // if (parms.length > 0) {
    //   await loadDefaultParameters(parms);
    // } else {
    //   await loadDefaultParameters();
    // }
    
  } catch (error) {
    console.error('SignalR 启动失败:', error);
  }
});

onUnmounted(async () => {
  try {
    stopRealTimeSubscription();
    stopAutoRefresh();
    off("ReceiveMessage", handleRealTimeData);
    unsubscribeConnected();
    stop();
    stopTracking();
  } catch (error) {
    console.error('清理失败:', error);
  }
});

// 暴露方法给父组件
defineExpose({
  handleTabChange,
  saveQueryVariables,
  loadQueryVariables,
  clearSavedVariables: () => {
    try {
      const storageKey = getStorageKey();
      localStorage.removeItem(storageKey);
      queryVarDevices.value = {};
      queryVariableNames.value = [];
      console.log('已清除本地存储的查询变量选择');
    } catch (error) {
      console.error('清除查询变量选择失败:', error);
    }
  }
});
</script>

<style scoped>
/* 基础动画 */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 连接状态 */
.connection-status {
  margin-bottom: 16px;
  animation: fadeIn 0.5s;
}

/* 主容器 */
.parameter-container {
  padding: 0px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  color: #2d3748;
  padding: 5px;  
}

.content-wrapper {
  height: 100%;
  overflow: hidden;  
  display: flex;  
  flex-direction: column;
  gap: 5px;
}

/* 滚动条美化 */
.content-wrapper::-webkit-scrollbar {
  width: 8px;
}

.content-wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
}

.content-wrapper::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.3);
  border-radius: 4px;
}

.content-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.5);
}

/* 数据网格布局 - 一行五个项 */
.data-grid {
  height: calc(100%);
  overflow: auto;  
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1px;
  margin-bottom: 10px;
  padding: 5px;
  flex: 1;
  animation: fadeIn 0.6s ease-out;
}

/* 数据项样式 padding: 18px;- 保持原来的样式 */
.data-item {
  display: flex;
  align-items: center;  
  padding-top: 10px;    /* 上边距 */
  padding-right: 18px;  /* 右边距 */
  padding-bottom: 10px; /* 下边距 */
  padding-left: 8px;    /* 左边距 */
  border-radius: 8px;
  transition: all 0.3s ease;
  background: transparent;
  border: none;
  box-shadow: none;
}

.data-item:hover {
  background: rgba(24, 144, 255, 0.05);
}

.data-item.selected {
  background: rgba(24, 144, 255, 0.1);
}

/* ========== 单行布局：标题、变量名、报警状态、重置按钮 ========== */
.checkbox-section {
  width: 100%;
}

.checkbox-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

/* 单行布局容器 */
.single-row-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
}

/* 标题和变量名区域 */
.title-var-area {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

/* 复选框容器 */
.checkbox-container {
  flex-shrink: 0;
  margin-top: 2px;
}

/* 标题文本 - 包含标题和变量名 */
.title-text {
  flex: 1;
  min-width: 0;
  font-size: 13px !important;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.4;
  
  /* 中文换行设置 - 超过9个汉字换行 */
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
  
  /* 自动换行，不限制行数 */
  white-space: normal;
  display: block;
  overflow: visible;
  text-overflow: unset;
  
  margin: 0;
  /* 移除高度限制，让内容自然换行 */
  max-height: none;
  min-height: auto;
  padding-top: 1px;
  
  /* 强制中文换行 */
  word-break: break-word;
  hyphens: auto;
}

/* 报警状态和重置按钮区域 */
.alarm-reset-area {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.alarm-status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
  white-space: nowrap;
  cursor: help;
  transition: all 0.3s ease;
  position: relative;
}

/* 当有描述信息时，添加特殊样式 */
.alarm-status.has-description:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Tooltip 自定义样式 
:deep(.el-tooltip__trigger) {
  display: inline-block;
}*/

/* 状态颜色 */
.status-normal {
  background: #2ecc71;
  color: white;
}

.status-normal:hover {
  background: #27ae60;
  box-shadow: 0 0 0 2px rgba(46, 204, 113, 0.3);
}

.status-alarm {
  background: #e74c3c;
  color: white;
}

.status-alarm:hover {
  background: #c0392b;
  box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.3);
}

.status-locked {
  background: #f39c12;
  color: white;
}

.status-locked:hover {
  background: #d35400;
  box-shadow: 0 0 0 2px rgba(243, 156, 18, 0.3);
}

.status-comm-error {
  background: #95a5a6;
  color: white;
}

.status-comm-error:hover {
  background: #7f8c8d;
  box-shadow: 0 0 0 2px rgba(149, 165, 166, 0.3);
}

/* 重置按钮样式 */
.reset-btn {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  border: none;
  font-weight: 600;
  width: 40px;
  flex-shrink: 0;
  font-size: 12px;
  padding: 6px 12px;
  white-space: nowrap;
}

.reset-btn:hover:not(.is-disabled) {
  background: linear-gradient(135deg, #2980b9 0%, #2471a3 100%);
  transform: translateY(-1px);
}

.reset-btn.is-disabled {
  background: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}

/* 分页区域样式保持不变 */
.pagination {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 0;
  gap: 16px;
}
.all-mode {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* 修改 .all-data-info 样式 */
.all-data-info {
  color: #64748b;
  font-size: 14px;
  padding: 8px 16px; /* 增加水平内边距 */
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  min-width: 180px; /* 设置最小宽度 */
  max-width: 300px; /* 设置最大宽度，避免过长 */
  white-space: normal; /* 允许换行 */
  word-break: break-word; /* 允许单词内换行 */
  text-align: center;
}

/* 自定义分页样式 */
.custom-page-size {
  width: 120px;
}

/* 修复复选框标签布局 */
:deep(.inline-checkbox .el-checkbox) {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0;
  width: 100%;
}

:deep(.inline-checkbox .el-checkbox__label) {
  display: block !important;
  width: 100%;
  padding-left: 0;
  color: #2d3748 !important;
  line-height: 1.4;
  font-size: 18px !important;
  font-family: 'Segoe UI', sans-serif;
}

:deep(.inline-checkbox .el-checkbox__input) {
  margin-top: 0;
  flex-shrink: 0;
}

/* 精确调整复选框位置 */
:deep(.inline-checkbox) {
  display: flex;
  align-items: flex-start;
}

:deep(.inline-checkbox .el-checkbox__input) {
  margin-top: 2px;
}

.inline-checkbox {
  flex-shrink: 0;
}

/* 保留原有的复选框样式 */
:deep(.el-checkbox) {
  width: 100%;
  align-items: center;
  margin-bottom: 0;
}

:deep(.el-checkbox__label) {
  width: 100%;
  padding-left: 12px;
  color: #2d3748 !important;
  line-height: 1.4;
  font-size: 18px !important;
  font-family: 'Segoe UI', sans-serif;
}

:deep(.el-checkbox__input) {
  margin-top: 0;
}

:deep(.el-checkbox__inner) {
  width: 22px !important;
  height: 22px !important;
  background: #ffffff;
  border: 2px solid #cbd5e0;
  transition: all 0.3s ease;
}

:deep(.el-checkbox__inner::after) {
  height: 11px !important;
  left: 7px !important;
  top: 3px !important;
  width: 6px !important;
  border-color: #1890ff;
  transition: all 0.3s ease;
}

:deep(.el-checkbox__inner:hover) {
  border-color: #1890ff;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background: #1890ff;
  border-color: #1890ff;
}

/* 分页区域样式 */
.pagination-container {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 24px;
  border: 1px solid #e2e8f0;
  gap: 20px;
  margin-top: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  min-width: 0; /* 确保可以缩小 */
}

.pagination-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 40px;
}

.selector-wrapper {
  flex: 1;
  min-width: 200px;
  max-width: 300px; 
}

.variable-selector:deep(.selector-header) {
  height: 36px;
  min-height: 36px;
  line-height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

.refresh-btn {
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 14px !important;
  padding: 12px 24px;
  height: 40px;
  background: linear-gradient(135deg, #1890ff, #36cfc9);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  color: #ffffff;
  transition: all 0.3s ease;
  font-family: 'Segoe UI', sans-serif;
}

.refresh-btn:hover {
  background: linear-gradient(135deg, #36cfc9, #1890ff);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.refresh-btn:active {
  transform: translateY(0);
}

/* 确保选择器组件内部样式正确 */
:deep(.project_variable-selector-container) {
  width: 100%;
}

:deep(.selector-header) {
  height: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/* 分页区域 */
/* 分页器容器 - 修复显示问题 */
.pagination {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 0; /* 允许缩小 */
  gap: 16px;
}

/* Element Plus 分页组件样式重写 */
:deep(.el-pagination) {
  color: #64748b;
  justify-content: flex-end;
  flex-wrap: wrap;
  font-size: 16px !important;
  font-family: 'Segoe UI', sans-serif;
}

:deep(.el-pagination__total) {
  color: #64748b !important;
  font-weight: 500;
  font-size: 16px !important;
}

:deep(.el-pagination__jump) {
  color: #64748b !important;
  font-weight: 500;
  font-size: 16px !important;
}

:deep(.el-pagination button) {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-size: 16px !important;
  font-weight: 500;
}

:deep(.el-pagination button:hover) {
  background: #f8fafc;
  border-color: #cbd5e0;
  color: #1890ff;
  transform: translateY(-1px);
}

:deep(.el-pagination .btn-prev),
:deep(.el-pagination .btn-next) {
  background: #ffffff;
}

:deep(.el-pagination .el-pager li) {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  margin: 0 4px;
  transition: all 0.3s ease;
  font-size: 16px !important;
  font-weight: 500;
}

:deep(.el-pagination .el-pager li:hover) {
  background: #f8fafc;
  border-color: #cbd5e0;
  color: #1890ff;
  transform: translateY(-1px);
}

:deep(.el-pagination .el-pager li.is-active) {
  background: linear-gradient(135deg, #1890ff, #36cfc9);
  border-color: #1890ff;
  color: #ffffff;
  font-weight: 600;
  transform: scale(1.05);
}

:deep(.el-pagination .el-select .el-input__inner) {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  font-size: 16px !important;
}

:deep(.el-pagination .el-select .el-input__suffix .el-icon) {
  color: #64748b;
}

:deep(.el-pagination .el-input__inner::placeholder) {
  color: #94a3b8;
}

:deep(.el-pagination .jumper .el-input__inner) {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  font-size: 16px !important;
}

/* 3. 弹窗样式：限制整体高度 */
:deep(.custom-dialog .el-dialog__body) {
  padding: 0;
  height: calc(100% - 60px);
  overflow: hidden;
}

/* 4. 弹窗内容容器：填充弹窗内容区 */
.dialog-content {
  height: 100%;
  padding: 0px;
  overflow: hidden;
  box-sizing: border-box;
}

/* 响应式设计 */
@media (max-width: 1600px) {
  .data-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1200px) {
  .data-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .pagination-container {
    flex-direction: column;
    gap: 16px;
  }
  
  .pagination-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .selector-wrapper {
    max-width: none;
    flex: 1;
  }
  
  .pagination {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .data-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  .single-row-layout {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  
  .alarm-reset-area {
    margin-left: 0;
    justify-content: flex-start;
  }
  
  .title-text {
    font-size: 16px !important;
    line-height: 1.3;
  }
  
  :deep(.inline-checkbox .el-checkbox__inner) {
    width: 20px !important;
    height: 20px !important;
  }
  
  :deep(.inline-checkbox .el-checkbox__inner::after) {
    height: 10px !important;
    left: 6px !important;
    top: 2px !important;
    width: 5px !important;
  }
  
  :deep(.el-checkbox__label) {
    font-size: 16px !important;
  }
  
  .pagination-actions {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
  
  .selector-wrapper {
    width: 100%;
    max-width: none;
  }
  
  .refresh-btn {
    width: 100%;
    font-size: 15px !important;
  }
  
  .pagination-container {
    padding: 12px 16px;
  }
}

@media (max-width: 480px) {
  .parameter-container {
    padding: 4px;
  }
  
  .data-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .title-text {
    font-size: 15px !important;
    line-height: 1.25;
  }
  
  :deep(.inline-checkbox .el-checkbox__inner) {
    width: 18px !important;
    height: 18px !important;
  }
  
  :deep(.inline-checkbox .el-checkbox__inner::after) {
    height: 9px !important;
    left: 5px !important;
    top: 1px !important;
    width: 4px !important;
  }
  
  :deep(.el-checkbox__label) {
    font-size: 15px !important;
  }
  
  .pagination-container {
    padding: 10px 12px;
  }
}

/* 追踪对话框样式 */
.auto-update-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 4px;
  border: 1px solid #e1f5fe;
  color: #0288d1;
  font-size: 14px;
}

.duration-input {
  display: flex;
  align-items: center;
  gap: 8px;
}

.duration-unit {
  color: #666;
  font-size: 14px;
}

.duration-tips {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.custom-interval-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.interval-unit {
  color: #666;
  font-size: 14px;
  white-space: nowrap;
}

.tracking-status {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.remaining-time {
  font-size: 14px;
  color: #1890ff;
  font-weight: 500;
}

.current-interval {
  font-size: 13px;
  color: #52c41a;
  font-weight: 500;
}

.stop-btn {
  margin-right: auto;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .edit-dialog-content {
    padding: 10px;
  }
  
  :deep(.el-form-item__label) {
    width: 120px !important;
  }
  
  :deep(.el-form-item__content) {
    margin-left: 120px !important;
  }
  
  .custom-interval-input {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
</style>